import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'start.learning': {
    id: 'start.learning',
    defaultMessage: 'Start learning',
    description: 'Header text for logistration MFE pages',
  },
  'with.site.name': {
    id: 'with.site.name',
    defaultMessage: 'with {siteName}',
    description: 'Header text with site name for logistration MFE pages',
  },
  'start.learning.ats': {
    id: 'start.learning.ats',
    defaultMessage: 'De unde încep să Predau Viitor?',
    description: 'ATS branded header text on the login/register page side panel',
  },
});

export default messages;
